module.exports = __webpack_public_path__ + "img/1eb32b9.png";